import { SET_USER_CASES, REMOVE_USER_CASES } from "../types";

export default function userCases(state = {}, action = {}) {
  switch (action.type) {
    case SET_USER_CASES: {
      return {
        ...state,
        userCases: action.userCases,
      };
    }
    case REMOVE_USER_CASES:
      return { ...state, userCases: undefined };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/userCases.js